module.exports = __webpack_public_path__ + "img/emo_10.dc3924f0.png";